import React, { Component } from 'react';

import './Home.css'

import MainTop from './Header';
import PromoPage from './PromoPage';
import FunctionPage from './FunctionPage';
import HelpPage from './HelpPage';
import Menu from './Menu'
import { Link } from 'react-router-dom';

class Home extends Component {
  render() {
    return (
      <div className="Home">
          <header>
            <a href="/" className="title"><h1>MIDNIGHT LIBRARY</h1></a>
            <Menu/>
          </header>
          <MainTop/>
          {/* 
          <div id="news"><PromoPage/></div>
          */}
          <div id="app"><FunctionPage/></div>
          <div id="about"><HelpPage/></div>
          <footer>
            <div>
              <span className="ci">LEMONCAKE</span>
              <div className="ci" style={{width:"40px"}}/>
              <span className="copyrights">Copyright ©2020 LEMONCAKE All Rights Reserved.</span>
              <div style={{width:"40px"}}>
                <hr style={{border: "solid 1px #222222", height:"10px"}}/>
              </div>
              <Link to="/privacy" className="privacy">개인정보처리방침</Link>
            </div>
          </footer>
        </div>
    );
  }
}

export default Home;